import { PopoverPosition } from '@blueprintjs/core';
import * as React from 'react';
import { ItemSelector } from 'vet-bones/components';
import { SelectItem } from 'vet-bones/utils/select';

import { TEST_IDS, getClassItemTestId } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import { stopPropagation } from 'src/utils/handlers/stopPropagation';

interface CreateMappingDialogClassSelectorProps {
  classItems: SelectItem[];
  handleSelectClass: (item: SelectItem | null) => void;
  selectedClassItem: SelectItem | null;
}

export const CreateMappingDialogClassSelector: React.VFC<
  CreateMappingDialogClassSelectorProps
> = ({ classItems, handleSelectClass, selectedClassItem }) => {
  return (
    <ItemSelector.Single
      buttonText={
        selectedClassItem?.text ||
        copy.components.classSelector.singularPlaceholder
      }
      filterInputProps={
        {
          'data-testid': TEST_IDS.createMappingDialog.classSelectorFilter,
          placeholder: copy.components.defaults.filter,
        } as any
      }
      items={classItems}
      itemTestId={getClassItemTestId}
      onButtonClick={stopPropagation}
      onClear={stopPropagation}
      onSelect={handleSelectClass}
      popoverProps={{
        backdropProps: { onClick: stopPropagation },
        popoverClassName: 'sd-create-mapping-class-menu',
        position: PopoverPosition.BOTTOM,
      }}
      resetOnClose
      selected={selectedClassItem || null}
      testId={TEST_IDS.createMappingDialog.classSelector}
    />
  );
};
